<template>
  <div class="conclusion">
    <div class="ground"></div>
    <h3><span>3</span><span>Imprimez votre liste :</span></h3>
    <div class="conclusion-table">
      <div class="conclusion-label">
        <div class="conclusion-label__text">Femme enceinte</div>
        <div class="conclusion-label__text">Adulte avec de jeunes enfants</div>
        <div class="conclusion-label__text">Couple</div>
      </div>
      <div class="conclusion-img">
        <div class="conclusion-img__img"><img src="./../assets/femme_enceinte.png" width="185"></div>
        <div class="conclusion-img__img"><img src="./../assets/homme_enfants.png" width="255"></div>
        <div class="conclusion-img__img"><img src="./../assets/couple.png" width="295"></div>
      </div>
      <div class="conclusion-list">
        INCONTOURNABLES
        <ul class="conclusion-incontournables">
        </ul>
        OPTIONNELS
        <ul class="conclusion-optionnels">
        </ul>
      </div>
      <div class="conclusion-print">
        <img src="./../assets/imprimante.png">
        <button @click="clickPrint"><svg><use xlink:href="#print"></use></svg>Imprimer la liste</button>
        <!--
        <div class="conclusion-social">
          <span>
            <a title="Facebook" @click="clickFacebook">
              <img src="./../assets/conclusion_facebook.png">
            </a>
          </span>
          <span>
            <a @click="clickTwitter">
              <img src="./../assets/conclusion_twitter.png">
            </a>
          </span>
        </div>
        -->

      </div>
    </div>
    <div class="conclusion-mention">
      <svg><use xlink:href="#attention"></use></svg>&nbsp;Le médicament n'est pas un produit comme les autres, pour en savoir plus rapprochez-vous
de votre médecin traitant ou votre pharmacien
    </div>
  </div>
</template>

<script>
  
import config from './../config';
  
export default {
  name: 'conclusion',
  data () {
    return {
      startX: 0,
      startY: 0,
      initialMouseX: 0,
      isEnd: false,
      nbTimes: 0
    }
  },
  created: function() {
    //
  },
  mounted: function() {

    document.querySelector(".buttonPrint").classList.add("hide");
    document.querySelector(".buttonChange").classList.add("hide");
    document.querySelector(".buttonRestart").classList.remove("hide");
    document.querySelector(".popin").classList.add("hide");

    const imgs = this.$el.querySelectorAll(".conclusion-img__img");
    const labels = this.$el.querySelectorAll(".conclusion-label__text");
    for(let i=0; i < imgs.length; i++) {
      if(i != config.current) {
        imgs[i].classList.add("hide");
        labels[i].classList.add("hide");
      }
    }

    let strInc = "";
    let strOpt = "";
    let tmpGroup = "c";

    if(config.current == 1) {
      tmpGroup = 'b';
      this.$el.querySelector(".conclusion-list").classList.add("conclusion-list--small");
    } else if(config.current == 2) {
      tmpGroup = 'd';
    } 
    /*
    a = commun
    b = femme avec enfants
    c = femme enceinte
    d = femme en couple
    */
    for (const key of Object.keys(config.some) ) {
      if(config.some[key].group.includes(tmpGroup) || config.some[key].group == "a") {
        if(config.some[key].category == 1) strInc += "<li>" + config.some[key].name + "</li>";
        if(config.some[key].category == 2) strOpt += "<li>" + config.some[key].name + "</li>";
      }
    }
    this.$el.querySelector(".conclusion-incontournables").innerHTML = strInc;
    this.$el.querySelector(".conclusion-optionnels").innerHTML = strOpt;
  },
  methods: {
    clickPrint: function() {
      let urlPrint = "static/pdf/Femme_enceinte.pdf";
      if(config.current == 1) {
        urlPrint = "static/pdf/Adulte_enfants.pdf";
      } else if(config.current == 2) {
        // urlPrint = "http://www.prioritesantemutualiste.fr/upload/docs/application/pdf/2012-03/femme-en-couple.pdf";
        // let urlPrint = "https://docs.mutualite.fr/medias/quiz/jeu-trousse-pharmacie/femme_enceinte.pdf";
        urlPrint = "static/pdf/Couple.pdf";
      }
      window.open(urlPrint);
    },
    clickFacebook: function(event) {
      let linkQuiz = document.querySelector('meta[property="og:url"]').getAttribute("content");
      let linkFacebook = 'https://www.facebook.com/sharer/sharer.php?u=' + linkQuiz + '&display=popup&ref=plugin';
      window.open(linkFacebook);
    },
    clickTwitter: function(event) {
      let linkQuiz = document.querySelector('meta[property="og:url"]').getAttribute("content");
      let shareText = document.querySelector('meta[property="og:title"]').getAttribute("content");
      let linkTwitter = 'https://twitter.com/share?url=' + linkQuiz + '&text=' + shareText + '&original_referer=' + linkQuiz + '&lang=fr';
      window.open(linkTwitter);
    },
  }
}
</script>

<style lang="scss" scoped>
  
  @import "../common.scss";

  .conclusion-table {
    display: flex;
    /*
    div {
      display: table-cell;
      vertical-align: top;
    }
    */
  }

  .conclusion-label {
    position: absolute;
    bottom: 30px;
    left: 20px;
    font-weight: bold;
  }

  .conclusion-mention {
    position: absolute;
    bottom: 15px;
    right: 110px;
    text-align: left;
    font-size: 0.8rem;
    color: $red;
    width: 545px;
    a {
      font-size: 0.63rem;
      color: #999;
      &:hover {
        color: #333;
      }
    }
    svg {
      width: 15px;
      height: 15px;
    }
  }

  .conclusion-img {
    width: 400px;
  }

  .conclusion-list {
    text-align: left;
    width: 40%;
  }
  
  .conclusion-incontournables, .conclusion-optionnels {
    font-size: 0.8rem;
  }

  .conclusion-list--small {
    .conclusion-incontournables, .conclusion-optionnels {
      margin-top: 0;
      font-size: 0.7rem;
    }
  }

  .conclusion-img__img:nth-child(2) {
    span {
      margin-top: -15px;
      display: block;
    }
  }

  .conclusion-img__img:nth-child(3) {
    margin-top: -30px;
    display: block;
    span {
      margin-top: -15px;
      display: block;
    }
  }

  .conclusion-print {
    button {
      background-color: $red;
      border: 0;
      color: #fff;
      font-weight: bold;
      border-radius: 15px;
      padding-left: 10px;
      transition: 0.5s background-color;
      &:hover {
        cursor: pointer;
        background-color: lighten($red, 15%);
      }
      svg {
        width: 20px;
        height: 20px;
        margin: -2px 5px -8px 0 !important;
        fill: #fff;
      }
    }
  }

  .conclusion-social {
    display: block !important;
    margin-top: 15px;
    a {
      cursor: pointer;
      img {
        transition: 0.5s -webkit-filter;
      }
      &:hover img {
        -webkit-filter: brightness(140%); /* Safari */
        filter: brightness(140%);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// 4-Conclusion.vue?8f3c507e